import { render } from "./CategoryMatching.vue?vue&type=template&id=3e8abbd0"
import script from "./CategoryMatching.vue?vue&type=script&lang=js"
export * from "./CategoryMatching.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__